import { render, staticRenderFns } from "./renewalRatioDetails.vue?vue&type=template&id=211c7d16&scoped=true&"
import script from "./renewalRatioDetails.vue?vue&type=script&lang=js&"
export * from "./renewalRatioDetails.vue?vue&type=script&lang=js&"
import style0 from "./renewalRatioDetails.vue?vue&type=style&index=0&id=211c7d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211c7d16",
  null
  
)

export default component.exports